<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active"><a href="javascript:;">Home</a></li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('worker_header_name') }} <!--<small class="ml-2">{{ $t('worker_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:workers="workers.workers"
						:worker="worker"
						:workerCreateCall="workerCreateCall"
						:workerEditCall="workerEditCall"
						:workerDeleteCall="workerDeleteCall"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
    name: 'Worker',
	components: {
		PageContentContainer,
	},
	data() {
		return {
			dataChanged: false,
		}
	},
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
    computed: {
        ...mapState('worker', ['workers', 'worker']),
    },
    methods: {
        ...mapActions('worker', ['getWorkers', 'getWorker', 'createWorker', 'editWorker', 'deleteWorker']),
		workerCreateCall(data) {
			this.createWorker(data);
            this.$router.push("/worker");
			this.dataChanged = true;
        },
		workerEditCall(workerId, workerData) {
			this.editWorker({ workerId, workerData });
			this.$router.push("/worker");
			this.dataChanged = true;
		},
		workerDeleteCall(id) {
			this.deleteWorker(id);
			this.$router.push("/worker");
			this.dataChanged = true;
		},
    },
    mounted() {
		if (!this.workers.length) {
			this.getWorkers();
		}
		if (this.$route.params.id) {
			this.getWorker(this.$route.params.id);
		}
	},
	watch: {
		dataChanged() {
			if (this.dataChanged) {
				this.getWorkers();
				this.dataChanged = false;
			}
		}
	},
}
</script>
